<template>
  <div @click="applyFn" class="apply-btn">我要报名</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { declarationRegistrationHasSameApply } from '@/api/personal/daclare'

export default {
  props: ['data'],
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    applyFn() {
      if (this.clickLoading) {
        return
      }
      this.clickLoading = true
      setTimeout(() => {
        this.clickLoading = false
      }, 2000)
      const time = Date.now()
      if (this.data.startTime && +new Date(this.data.startTime) > time) {
        return this.$message.warning('报名暂未开始')
      // } else if (+new Date(this.data.endTime) < time) {
      //   return this.$message.warning('报名已经结束')
      }
      declarationRegistrationHasSameApply({
        planProject: this.data.planManagement,
        employerId: this.data.employerId,
        mainOrg: this.data.mainOrg,
        applicationCategory: this.data.postType,
        // twoApplicationCategory:  //二类
        talentPlanPost: this.data.id,
        declarerId: this.userInfo.id,
        talentPlanRelease: this.data.talentPlanRelease
      }).then(res => {
        console.log(res, 'declarationRegistrationHasSameApply')
        if (res.data.isRegistrationEnd) {
          if (res.data.crossCategorical) {
            // if (!res.data.isPlanProjectRepeat) {
            //   return this.$message.warning(res.data.isPlanProjectRepeatMsg)
            // }
            if (res.data.isApply && res.data.staging) {
              this.$router.push({
                path: '/personal/declare-list/declare-apply',
                query: {
                  planId: this.$route.query.planId,
                  postId: this.$route.query.postId,
                  applied: res.data.isApply,
                  storage: res.data.staging
                }
              })
            } else if (!res.data.isApply && res.data.staging) {
              this.$message.warning(res.data.isApplyMsg)
            } else if (res.data.isApply && !res.data.staging) {
              this.$message.warning(res.data.stagingMsg)
            } else if (!res.data.isApply && !res.data.staging) {
              this.$message.warning(res.data.isApplyMsg)
            }
          } else {
            this.$message.warning(res.data.crossCategoricalMsg)
          }
        } else {
          this.$message.warning(res.data.isRegistrationEndMsg)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.apply-btn {
  margin: 20px auto 0;
  width: 240px;
  height: 40px;
  background-color: #146CB7;
  color: #fff;
  font-size: 16px;
  line-height: 40px;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
}
</style>